import "./App.css";
import { Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import routes from "./routes/routes";
import ScrollToTopNav from "./components/ScrollToTopNav";
import Loader from "./components/Loader";

/**
 * Loading fallback component
 */
const LoadingFallback = () => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "100vh",
    }}>
    <Loader size="lg" label="Loading app..." />
  </div>
);

/**
 * Main App Component
 */
function App() {
  return (
    <>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#0b0524",
            color: "#ffffff",
            border: "1px solid rgba(74, 115, 255, 0.3)",
          },
          success: {
            iconTheme: {
              primary: "#00a3f9",
              secondary: "#ffffff",
            },
          },
          error: {
            iconTheme: {
              primary: "#ff4b4b",
              secondary: "#ffffff",
            },
          },
        }}
      />
      <Router>
        <ScrollToTopNav />
        <Suspense fallback={<LoadingFallback />}>
          <Routes>
            {routes.map((route) => (
              <Route
                key={route.path}
                path={route.path}
                element={route.element}
              />
            ))}
          </Routes>
        </Suspense>
      </Router>
    </>
  );
}

export default App;
